<template>
  <div class="closedloop">
    <div class="header">
      <div class="title">工单流程闭环</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <img :src="mobilereportforrepair3" alt="" />
      </div>
      <div class="right">
        <div class="item" v-for="item in closedloopList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilereportforrepair3 from "../../../../assets/product/mobilereportforrepair3.png";

export default {
  setup() {
    return reactive({
      mobilereportforrepair3: mobilereportforrepair3,
      closedloopList: [
        {
          id: 1,
          title: "全程闭环",
          text: "待完成的事项的工单无需进行二次申请，系统自动导入新工单，提升效率。",
        },
        {
          id: 2,
          title: "进度消息提醒",
          text: "工单后台智能分析，进度消息全程提醒。",
        },
        {
          id: 3,
          title: "自动派单",
          text: "有任务系统自动派单，智能协助运营，提升客户满意度。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.closedloop {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  text-align: center;
  margin-top: 16px;
}
.body .left img {
  width: 343px;
}
.body .right .item {
  margin-top: 12px;
  text-align: left;
  font-size: 14px;
}
.body .right .item .title {
  font-weight: 600;
}
.body .right .item .text {
  margin-top: 8px;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
